import React, {PropTypes} from 'react';
import {ListItem} from 'material-ui/List';
import { BlogIcon, TakeActionIcon } from '../Icons';
import ContentItemAction from './ContentItemAction';
import IsReadTitle from './IsReadTitle';

const BlogItem = ({item}) => {
  return (
    <div>
      <ContentItemAction>
        <ListItem primaryText={<IsReadTitle title={item.title} read={item.read}/>}
          leftIcon={<BlogIcon />}
          rightIcon={<TakeActionIcon />}
          item={item}
        />
      </ContentItemAction>
    </div>
  );
};

BlogItem.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    read: PropTypes.boolean
  })
};

export default BlogItem;



/** WEBPACK FOOTER **
 ** ./src/components/common/content-items/BlogItem.js
 **/